<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <Factura msg="Tu Factura en linea GRATIS y sin registrarse"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Factura from '@/components/Factura.vue'

export default {
  name: 'Home',
  components: {
    Factura
  }
}
</script>
